package fr.frux.feature.treedetail.site

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Forest
import androidx.compose.material.icons.outlined.Link
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import fr.frux.core.designsystem.components.FruxButton
import fr.frux.core.designsystem.components.FruxButtonStyle
import fr.frux.core.designsystem.format.formatDistance
import fr.frux.feature.treedetail.resources.Res
import fr.frux.feature.treedetail.resources.treedetail_site_attach
import fr.frux.feature.treedetail.resources.treedetail_site_not_now
import fr.frux.feature.treedetail.resources.treedetail_site_proposal_body
import fr.frux.feature.treedetail.resources.treedetail_site_proposal_title
import org.jetbrains.compose.resources.stringResource

/**
 * Carte « Rattacher » (canvas `Rattacher`) : un arbre libre est à moins de 100 m d'un lieu ouvert.
 * La fiche de l'arbre ne change pas, seul le lieu le compte parmi les siens.
 */
@Composable
internal fun SiteAttachProposalCard(
    proposal: SiteProposal,
    busy: Boolean,
    onAttach: () -> Unit,
    onDismiss: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val scheme = MaterialTheme.colorScheme
    Surface(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(20.dp),
        color = scheme.surface,
        border = BorderStroke(1.dp, scheme.outlineVariant),
        shadowElevation = 2.dp,
    ) {
        Column(modifier = Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(16.dp)) {
            Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                Box(
                    modifier = Modifier.size(44.dp).background(scheme.primaryContainer, CircleShape),
                    contentAlignment = Alignment.Center,
                ) {
                    Icon(
                        imageVector = Icons.Outlined.Forest,
                        contentDescription = null,
                        tint = scheme.onPrimaryContainer,
                        modifier = Modifier.size(22.dp),
                    )
                }
                Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    Text(
                        text =
                            stringResource(
                                Res.string.treedetail_site_proposal_title,
                                formatDistance(proposal.distanceMeters),
                                proposal.site.name,
                            ),
                        style = MaterialTheme.typography.titleMedium,
                    )
                    Text(
                        text = stringResource(Res.string.treedetail_site_proposal_body),
                        style = MaterialTheme.typography.bodyMedium,
                        color = scheme.onSurfaceVariant,
                    )
                }
            }
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                FruxButton(
                    text = stringResource(Res.string.treedetail_site_not_now),
                    onClick = onDismiss,
                    style = FruxButtonStyle.Outline,
                    enabled = !busy,
                    modifier = Modifier.weight(1f),
                )
                FruxButton(
                    text = stringResource(Res.string.treedetail_site_attach),
                    onClick = onAttach,
                    loading = busy,
                    icon = Icons.Outlined.Link,
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}
